import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
import { formatToMMDD } from "global/helpers";
Chart.register(...registerables);

const LineCharts = ({ graphData, analysis, filterBy, filterByUser, updateFilter }) => {
  const chartRef = useRef(null);
  const labels = graphData?.labels || [];
  const formattedDateLabel = labels.map(formatToMMDD);
  const datasets = graphData?.datasets || [];
  const preparedDatasets = datasets.map((dataset) => ({
    label: dataset.label,
    data: dataset.data,
    borderColor: dataset.backgroundColor,
    backgroundColor: dataset.backgroundColor,
    pointRadius: 6,
    fill: false,
    pointHoverRadius: 6, // Size of the point on hover
    pointHitRadius: 5,
  }));

  const config = {
    type: "line",
    data: {
      labels: formattedDateLabel,
      datasets: preparedDatasets,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: "top",
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              const datasetLabel = tooltipItem.dataset.label || "";
              const dataPoint = tooltipItem.raw || 0;
              return `${datasetLabel}: ${dataPoint}`;
            },
          },
        },
        datalabels: {
          display: false,
        },
      },
      interaction: {
        mode: "point",
        intersect: false,
      },
      scales: {
        y: {
          suggestedMin: 0,
          suggestedMax: Math.max(...datasets.flatMap((ds) => ds.data)) + 10,
        },
        x: {
          title: {
            display: false,
          },
        },
      },
    },
  };

  useEffect(() => {
    const ctx = document.getElementById("myChart").getContext("2d");
    if (chartRef.current) {
      chartRef.current.destroy();
    }
    chartRef.current = new Chart(ctx, config);

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [graphData, updateFilter, filterBy, filterByUser]);

  return (
    <>
      <div>
        <canvas id="myChart"></canvas>
      </div>

      <div className="processedchart-bottom">
        <div className="p-4">
          <div className="d-flex align-items-center justify-content-center gap-4">
            {updateFilter === "claimScrubber" ? (
              <div className="d-flex align-items-center gap-2">
                <div className="processed-label completed"></div>
                <p className="mb-0">Claim Scrubber</p>
              </div>
            ) : filterBy === "assignedVsAssignedTo" ? (
              <>
                <div className="d-flex align-items-center gap-2">
                  <div className="processed-label completed"></div>
                  <p className="mb-0">Amount User Assigned to Others</p>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="processed-label received"></div>
                  <p className="mb-0">Amount Assigned to User</p>
                </div>
              </>
            ) : (
              <>
                {updateFilter !== "claimScrubber" && (
                  <div className="d-flex align-items-center gap-2">
                    <div className="processed-label worked"></div>
                    <p className="mb-0">Amount Worked</p>
                  </div>
                )}
                <div className="d-flex align-items-center gap-2">
                  <div className="processed-label completed"></div>
                  <p className="mb-0">Amount Completed</p>
                </div>
                {updateFilter !== "claimScrubber" && (
                  <div className="d-flex align-items-center gap-2">
                    <div className="processed-label received"></div>
                    <p className="mb-0">Amount Received</p>
                  </div>
                )}
              </>
            )}
          </div>
          {updateFilter !== "claimScrubber" && (
            <div className="fw-bold bottom-text mt-3">
              {/* {filterByUser === "All Users" && */}
              <div className="text-center">
                <p className="mb-0">{analysis?.headline}</p>
                <p>   {analysis?.subtitle}</p>
                {/* {analysis?.goalLine} */}
              </div>

              {/* } */}

            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LineCharts;